export default __webpack_public_path__ + "static/media/browse.79709be2.svg";